module.exports = __webpack_public_path__ + "kotori.png?8af6401bb749c73452e67229a2e985b5";


//////////////////
// WEBPACK FOOTER
// ./src/kotori.png
// module id = 5
// module chunks = 0